export default {
  name: 'Название',
  price: 'Цена',
  price_num2str: 'Цена прописью',
  start_time_format1: 'Дата начала',
  end_time_format1: 'Дедлайн'
}
